import { action, observable } from 'mobx';
import { databaseRef } from '../../helperFunctions/firebaseStore';
import { IUsersStore } from "../storeInterfaces/usersInterface";
import { IUser } from "../storeInterfaces/authStoreInterface";
import { convertObjToArray } from "./ordersStore";

export class UsersStore implements IUsersStore {

    @observable
    users: IUser[] = [];
    @observable
    loaded: boolean = false;
    @observable
    failed: boolean = false;

    @action
    async getUsers() {
        try {
            await databaseRef.ref('/users/').on('value', snapshot => {
                this.users = snapshot ? convertObjToArray(snapshot.val())
                    .sort((a, b) => {
                        if (a.name < b.name) { return -1; }
                        if (a.name > b.name) { return 1; }
                        return 0;
                    }) : []
                });
        } catch (e) {
            this.failed = true;
        } finally {
            this.loaded = true;
        }
    }
}